module.exports = __webpack_public_path__ + "static/media/Ruben Herrera.5c76ded4.jpg";